import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { selectPageModelTitle } from '../../../store/pageModel';
import { pageTitleStyles } from './style';

type PageTitleProps = {
	className?: string;
};

export const PageTitle = ({ className }: PageTitleProps) => {
	const title = useSelector(selectPageModelTitle);
	const cn = `${pageTitleStyles} ${className}`.trimRight();
	return (
		<Typography as="h1" variant="h1" className={cn} overrideStyles={false}>
			{title}
		</Typography>
	);
};
